import { useState } from 'react'

interface Actions {
  declareFailure?: boolean
  observation?: string
}
const MAX_CHARACTERS = 255
const MIN_CHARACTERS = 15

export const useValuesFinalForm = (initValues: Actions) => {
  const [actions, setActions] = useState<Actions>(initValues)

  const handleChangeAction = (name: keyof Actions) => {
    setActions((old) => {
      return {
        ...old,
        continue: false,
        [name]: !old[name],
      }
    })
  }

  const handleChangeObservation = (value: string) => {
    if (value.length > MAX_CHARACTERS) return
    setActions((old) => ({
      ...old,
      observation: value,
    }))
  }

  return { actions, handleChangeAction, handleChangeObservation, MAX_CHARACTERS, MIN_CHARACTERS }
}
